import * as api from '@/api/give-course/comment'
import * as TYPES from './type';

export default {
  //讨论
  async getSKCommentList({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKCommentList(paramets)
    commit(TYPES.SK_COMMENT_LIST, { result })
    cb && cb()
  },
  //讨论详情
  async getSKCommentDetails({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKCommentDetails(paramets)
    commit(TYPES.SK_COMMENT_DETAILS, { result })
    cb && cb()
  },
  //讨论添加
  async postSKCommentAdd({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKCommentAdd(paramets)
    commit(TYPES.SK_COMMENT_ADD, { result })
    cb && cb()
  },
  //讨论添加
  async putSKCommentEdit({ commit, state }, { paramets, cb }) {
    const result = await api.reqSKCommentEdit(paramets)
    commit(TYPES.SK_COMMENT_EDIT, { result })
    cb && cb()
  },
}



// WEBPACK FOOTER //
// ./src/store/give-course/comment/actions.js